import { render, staticRenderFns } from "./AccountUncHistoryBBR.vue?vue&type=template&id=679be37b&"
import script from "./AccountUncHistoryBBR.vue?vue&type=script&lang=js&"
export * from "./AccountUncHistoryBBR.vue?vue&type=script&lang=js&"
import style0 from "./AccountUncHistoryBBR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports